import React from 'react';
import { Voucher } from '../../types/Voucher';
import { Currency } from '@flixbus/honeycomb-react';

// Define the props
interface OriginalAmountProps {
  voucher: Voucher;
}

const OriginalAmount: React.FC<OriginalAmountProps> = ({ voucher }) => {
  if (!voucher.originalAmount) {
    return <>-</>;
  }

  return <Currency value={voucher.originalAmount.amount} code={voucher.originalAmount.currency} />;
};

export default OriginalAmount;
